import {fromEvent, map, merge, Observable} from "rxjs";

export class MediaUpload {
  public static uploadImage(): Observable<FileList> {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    this._addElementToDom(input);
    Promise.resolve().then(() => input.click());
    return merge(fromEvent<InputEvent>(input, 'change'), fromEvent<InputEvent>(input, 'blur')).pipe(map((event: FocusEvent | InputEvent) => {
      this._clean(input);
      return (event.target as HTMLInputElement).files as FileList;
    }));
  }
  public static uploadVideo(): Observable<FileList> {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'video/*';
    this._addElementToDom(input);
    Promise.resolve().then(() => input.click());
    return fromEvent<InputEvent>(input, 'change').pipe(map(event => {
      this._clean(input);
      return (event.target as HTMLInputElement).files as FileList;
    }));
  }
  private static _addElementToDom(input: HTMLInputElement) {
    input.style.position = 'absolute';
    input.style.top = '0';
    input.style.right = '0';
    input.style.opacity = '0';
    document.body.appendChild(input);
  }

  private static _clean(input: HTMLInputElement) {
    document.body.removeChild(input);
  }
  // public static uploadVideoOrPhoto(): Observable<FileList> {
  //   const input = document.createElement('input');
  //   input.type = 'file';
  //   input.accept = 'video/*,image/*';
  //   Promise.resolve().then(() => input.click());
  //   return fromEvent<InputEvent>(input, 'change').pipe(map(event => {
  //     return (event.target as HTMLInputElement).files as FileList;
  //   }));
  // }
}
